import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter, HashRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"
import store from "./store"
// to prevent too many files opened error
// const realFs = require('fs')
// const gracefulFs = require('graceful-fs')
// gracefulFs.gracefulify(realFs)


const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
)

ReactDOM.render(app, document.getElementById("root"))
serviceWorker.unregister()
